// STYLES
import * as Style from "./RentStatisticsStyle";

// LIBRARIES
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import Dayjs from "dayjs";

// MISC

// ASSETS
import CalendarDayIcon from "assets/Icons/CalendarDayIcon.svg";
import CalendarMonthIcon from "assets/Icons/CalendarMonthIcon.svg";
import CalendarWeekIcon from "assets/Icons/CalendarWeekIcon.svg";
import CalendarYearIcon from "assets/Icons/CalendarYearIcon.svg";

// REDUX
import { useAppDispatch } from "hooks/reduxHooks";
import { handleEndDateChange, handleStartDateChange } from "slices/filtersSlice";

// COMPONENTS
import RentStatisticElement from "../RentStatisticElement/RentStatisticElement";

const RentStatistics = ({ rentStatisticsData }) => {
  // PROPS

  // CONSTANTS USING LIBRARIES
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const date = Dayjs();

  // CONSTANTS USING HOOKS

  // GENERAL CONSTANTS

  // USE EFFECT FUNCTION

  // REQUEST API FUNCTIONS

  // HANDLERS FUNCTIONS
  const handleNavigateReports = (type) => {
    dispatch(
      handleStartDateChange(
        date.startOf(type).toDate()
      )
    );
    dispatch(
      handleEndDateChange(
        date.endOf(type).toDate()
      )
    );
    navigate("/reports");
  };

  return (
    <Style.RentStatisticsContainer>
      <Style.ContainerTitle>
        {t("page.dashboard.rentStatistics.title")}
      </Style.ContainerTitle>
      <Style.RentStatisticWrapper>
        <RentStatisticElement
          onClick={() => handleNavigateReports("day")}
          image={CalendarDayIcon || ""}
          title={t("page.dashboard.rentStatistics.currentDay")}
          value={rentStatisticsData.noOfCurrentDayRentals}
        />
        <RentStatisticElement
          onClick={() => handleNavigateReports("week")}
          image={CalendarMonthIcon || ""}
          title={t("page.dashboard.rentStatistics.currentMonth")}
          value={rentStatisticsData.noOfCurrentMonthRentals}
        />
        <RentStatisticElement
          onClick={() => handleNavigateReports("month")}
          image={CalendarWeekIcon || ""}
          title={t("page.dashboard.rentStatistics.currentWeek")}
          value={rentStatisticsData.noOfCurrentWeekRentals}
        />
        <RentStatisticElement
          onClick={() => handleNavigateReports("year")}
          image={CalendarYearIcon || ""}
          title={t("page.dashboard.rentStatistics.currentYear")}
          value={rentStatisticsData.noOfCurrentYearRentals}
        />
      </Style.RentStatisticWrapper>
    </Style.RentStatisticsContainer>
  );
};

export default RentStatistics;
